import React, { useState } from 'react';
import './AboutEvent.scss';
import { ContentStatusEnum, EndShowingDetails, PageDetails } from './Session';
import './EndEvent.scss';
import { ReactComponent as BackArrowIcon } from '../assets/chevron_backward_large.svg';
import { ReactComponent as ArrowIcon } from '../assets/arrow_forward_large.svg';
import Content from './Content';

export interface EndEventProps {
  back: () => void;
  details: EndShowingDetails;
}
const EndEvent: React.FC<EndEventProps> = ({ details, back }) => {
  const [page, setPage] = useState<PageDetails>();

  if (page) {
    return (
      <div className="end-container">
        <div className="content-header">
          <button onClick={() => setPage(undefined)} className="small">
            <BackArrowIcon /> Back
          </button>
        </div>
        <div className="content-container">
          <Content page={page} contentStatus={ContentStatusEnum.Showing} />
        </div>
      </div>
    );
  }

  return (
    <div
      className={`end-container ${details.pages.length > 1 ? 'end-container__pages' : ''}`}
    >
      <div className="content-header">
        <button onClick={back} className="small">
          <BackArrowIcon /> Back
        </button>
      </div>
      <h1>Thank you for attending</h1>
      {details.pages.map((p) => (
        <div className="button-group button-group__page" key={p.reference}>
          <button onClick={() => setPage(p)}>
            {p.name} <ArrowIcon />
          </button>
        </div>
      ))}
      {details.subscribeLink && (
        <div className="button-group">
          <p>Sign up to hear more from us</p>
          <a
            className="button primary"
            target="_blank"
            rel="noReferrer"
            href={details.subscribeLink}
          >
            Subscribe <ArrowIcon />
          </a>
        </div>
      )}
      {(details.donationPageLink || details.feedbackLink) && (
        <div className="button-group button-group-footer">
          {details.donationPageLink && (
            <div>
              <a
                className="button"
                target="_blank"
                rel="noReferrer"
                href={details.donationPageLink}
              >
                Make a donation
              </a>
            </div>
          )}
          {details.feedbackLink && (
            <div>
              <a
                className="button"
                target="_blank"
                rel="noReferrer"
                href={details.feedbackLink}
              >
                Give us feedback
              </a>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default EndEvent;
